import axios from "axios";
const instance = axios.create({
    baseURL: process.env.REACT_APP_API_KEY ,
    headers: {
      'Content-Type' : 'application/json' ,
      'Authorization': `Bearer ${localStorage.getItem("token")}`
  }
  });
  const responseHandler = response => {
    return response;
  };
  instance.interceptors.response.use(
    (response) => responseHandler(response) );
export default  instance 
